import React, { useState } from "react";
import { Link } from "react-router-dom";

import { CurrencyFormat } from "../../utils";

import useConfiguratorData from "../hooks/useConfiguratorData";
import useAccessoriesData from "../hooks/useAccessoriesData";
import useFinanciadoData from "../hooks/useFinanciadoData";
import usePriceData from "../hooks/usePriceData";
import useLeadData from "../hooks/useLeadData";
import ModalContact from "./Modals/ModalContactMe";

const BreadcrumbsModelDetail = ({ model, dealers, confirmation, empty }) => {
    const { getSelectedModel, getSelectedVersion } = useConfiguratorData();
    const selectedModel = getSelectedModel();
    const selectedVersion = getSelectedVersion();
    const { getIgnoreAccessories, getAddedAccessories } = useAccessoriesData();
    const { getIgnoreFinanciado } = useFinanciadoData();
    const addedAccessories = getAddedAccessories();

    const { updateLead } = useLeadData();
    const { getFinalPrice } = usePriceData();
    const finalPrice = getFinalPrice();
    const [modalContactisOpen, setModalContactIsOpen] = useState(false);

    const legend = () => {
        const ignoreAccessories = getIgnoreAccessories();
        const ignoreFinanciado = getIgnoreFinanciado();

        if (!ignoreAccessories.value && addedAccessories.length) {
            return <small>El precio incluye el valor de los accesorios</small>;
        }

        if (!ignoreAccessories.value && addedAccessories.length && !ignoreFinanciado.value) {
            return <small>El precio incluye accesorios y bono por financiaciamiento</small>;
        }

        if (ignoreAccessories.value && !ignoreFinanciado.value) {
            return <small>El precio incluye bono por financiaciamiento</small>;
        }

        return null;
    };

    const handleContactMeButton = () => {
        updateLead(
            [
                {
                    name: "quiero-que-me-contacten",
                    value: "Si",
                },
            ],
            () => {
                setModalContactIsOpen(true); // exito
            },
            () => {
                setModalContactIsOpen(true); // error
            }
        );
    };

    return (
        <>
            <nav className={"breadcrumb-nav" + (empty ? " empty" : "")}>
                <ul>
                    <li>
                        <Link to="/">Configura</Link>
                    </li>
                    {model ? <li>{selectedModel ? <a>{selectedModel.name}</a> : null}</li> : null}
                    {dealers ? (
                        <li>
                            <a>Elegir concesionaria</a>
                        </li>
                    ) : null}

                    {confirmation ? (
                        <li>
                            <a>Confirmación</a>
                        </li>
                    ) : null}
                </ul>
                {!empty ? (
                    <div className="contact">
                        <p>¿Necesitas asesoramiento?</p>
                        <a
                            className="btn black quiero-que-me-contacten"
                            onClick={() => handleContactMeButton()}
                        >
                            Quiero que me contacten
                        </a>
                    </div>
                ) : null}
            </nav>
            {model ? (
                <div className="model-and-price" id="model-and-price">
                    {/* <div className="model-and-price-container">
                        <div className="price-and-model">
                            <strong id="model-and-version">
                                {selectedModel && selectedVersion ? (
                                    <>{selectedModel.name} {selectedVersion.name}</>
                                ) : null}
                            </strong>
                            <span id="price">{CurrencyFormat(finalPrice)} <sup>(&lowast;)</sup></span>
                        </div>
                    </div> */}
                </div>
            ) : null}
            <ModalContact
                isOpen={modalContactisOpen}
                onCloseModal={() => setModalContactIsOpen(false)}
            />
        </>
    );
};

export default BreadcrumbsModelDetail;
